// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-edit-favorites-alias__content {
  padding: 30px 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogEditFavoritesAlias/DialogEditFavoritesAlias.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR","sourcesContent":[".dl-edit-favorites-alias__content {\n  padding: 30px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
